import type { ICustomOVDChangeEvent, OVDChangesEnum } from "./OVDJsonStore";

/**
 * Folds a change into another pending one, so a single dispatch still names
 * every Bay touched: the same type unions its `data`, a missing `data` means
 * "all of that type", and different types fall back to a full render.
 *
 * Only types are imported, so the store can use this without a require cycle.
 */
export function mergeOVDChanges(
  pending: ICustomOVDChangeEvent | undefined,
  change: ICustomOVDChangeEvent,
): ICustomOVDChangeEvent {
  if (pending === undefined) return change;

  if (pending.type !== change.type) return { type: "FULL" as OVDChangesEnum.FULL };

  if (pending.data === undefined || change.data === undefined) return { type: change.type };

  const data = [...pending.data, ...change.data].filter((v, i, a) => a.indexOf(v) === i);

  return { type: change.type, data } as ICustomOVDChangeEvent;
}
